<div class="modal" *transloco="let t; read: 'global.mfa'">
  <div class="modal__content">
    <div class="modal__content__text" [innerHTML]="hyphenate(t('disableMfaConfirm'))"></div>
    <form [formGroup]="form" class="user__section user__section--spaced">
        <div class="user__section__data mfa__data--left mfa__data--verify">
          <div class="user__section__data__value">
            <div class="mfa__input-container">
              <ha-input
                id="code"
                formControlName="verificationCode"
                autocomplete="one-time-code"
                inputmode="numeric"
                enterkeyhint="done"
                autocapitalize="off"
                autocorrect="off"
                [maxlength]="6"
                class="mfa__input"
                type="text"
                [label]="t('codeLabel')"
                (input)="resetError($event)">
              </ha-input>
            </div>
            <div class="mfa__input-error" *ngIf="!form.controls.verificationCode.invalid && error">
              {{ t(error) }}
            </div>
            <div class="mfa__input-error"
                 *ngIf="form.controls.verificationCode.touched
                        && form.controls.verificationCode.invalid">
              {{ t('codeError') }}
            </div>
          </div>
        </div>
      </form>
  </div>

  <div class="modal__actions">
    <button class="modal__actions__cancel" type="button" (click)="closeModal()">{{ t('cancel') }}</button>
    <button class="modal__actions__delete" type="button" [loading]="DisableAction" [disabled]="form.pristine || form.invalid" [class.modal__actions__delete--disabled]="form.pristine || form.invalid" (click)="confirm()">{{ mobileDisableLabel() }}</button>
  </div>
</div>


